import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';

import { ApproveOrDeniedEPOViaEmail } from '../../services/expense-purchase-order';
import useQuery from '../../custom-hooks/useQuery';
import Approveimg from '../../assets/images/Approvd.png';
import Deniedimg from '../../assets/images/Denied.png';

export const ThankyouPageForEpo = () => {
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const { epoId } = useParams();
  const query = useQuery();

  const approvalCase = query.get('case') || '';
  const userId = query.get('userid') || '';
  const isApprove = query.get('isApprove') || '';

  const SubmitApproval = async () => {
    try {

      const response = await ApproveOrDeniedEPOViaEmail(
        epoId,
        isApprove,
        userId,
        approvalCase
      );

      if (response.status === 200) {
        if (isApprove === 'true') {
          setMessage('Epo Approval successfully');
        } else {
          setMessage('Epo Denied successfully');
        }
        setSuccess(true);
      } else {
        setMessage('Epo is not submitted');
        setSuccess(false);
      }
    } catch (error) {
      setMessage('An error occurred while submitting EPO');
      setSuccess(false);
    }
  };

  const hasCalled = useRef(false);

  useEffect(() => {
    if (!epoId || !userId || !isApprove) return;

    if (hasCalled.current) return;

    const key = `epo_${epoId}_${userId}_${isApprove}`;

    if (sessionStorage.getItem(key)) return;

    hasCalled.current = true;
    sessionStorage.setItem(key, "called");

    SubmitApproval();
  }, [epoId, userId, isApprove]);

  return (
    <div style={{ textAlign: 'center' }}>
      {success ? (
        isApprove === 'true' ? (
          <img src={Approveimg} alt="Approved" height="100%" width="100%" />
        ) : (
          <img src={Deniedimg} alt="Denied" height="100%" width="100%" />
        )
      ) : (
        <div style={{ height: '100vh' }} />
      )}
    </div>
  );
};